/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";

const IsProduction = !["development", "test"].some(env => process.env.REACT_APP_RD_ENV == env)

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID!,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID!}`,
        // knownAuthorities: [],
        // cloudDiscoveryMetadata: "",
        redirectUri: process.env.REACT_APP_REDIRECT_URI
        // postLogoutRedirectUri: "enter_postlogout_uri_here",
        // navigateToLoginRequestUrl: true,
        // clientCapabilities: ["CP1"]
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        secureCookies: true
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii || IsProduction) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: !IsProduction
        },
        // windowHashTimeout: 60000,
        // iframeHashTimeout: 6000,
        // loadFrameTimeout: 0,
        // asyncPopups: false
    },
    // telemetry: {
    //     application: {
    //         appName: "My Application",
    //         appVersion: "1.0.0"
    //     }
    // }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // scopes: ["User.Read"]
    // scopes: ["api://54005081-5351-4f3c-a2bd-9cad1a9e2919/readwrite"]
    scopes: [process.env.REACT_APP_SCOPE_API!]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: process.env.REACT_APP_GRAPH_ME_ENDPOINT
};
